import React, { useState } from 'react';
import { Button } from '../components/UI/Button';
export const HostSalon = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    location: '',
    role: '',
    aboutYou: '',
    inspiration: '',
    attendees: '',
    existingCommunity: '',
    communityDescription: '',
    promotionPlan: '',
    experience: '',
    eventDescription: '',
    engagementPlan: '',
    orientationAvailability: '',
    documentationWillingness: '',
    agreement: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    try {
      const response = await fetch('https://formspree.io/f/xnngonyv', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        setFormData({
          fullName: '',
          email: '',
          phone: '',
          location: '',
          role: '',
          aboutYou: '',
          inspiration: '',
          attendees: '',
          existingCommunity: '',
          communityDescription: '',
          promotionPlan: '',
          experience: '',
          eventDescription: '',
          engagementPlan: '',
          orientationAvailability: '',
          documentationWillingness: '',
          agreement: ''
        });
        setIsSubmitted(true);
      } else {
        throw new Error('Failed to submit form');
      }
    } catch (err) {
      setError('There was an error submitting your application. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  if (isSubmitted) {
    return <div className="pt-20 bg-white min-h-screen" data-id="element-3252">
        <div className="container mx-auto px-4 py-16" data-id="element-3253">
          <div className="max-w-3xl mx-auto" data-id="element-3254">
            <div className="bg-white p-8 rounded-lg border-2 border-gray-300 text-center" data-id="element-3255">
              <h2 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-3256">
                Thank you for applying to host a Networking Salon!
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-3257">
                Your submission has been received, and our team will review it
                carefully. If selected, you'll receive hosting guidelines,
                support resources, and a short orientation session to help you
                plan your event.
              </p>
              <p className="text-gray-700 mb-8" data-id="element-3258">
                Together, we'll keep building spaces where connections turn into
                real opportunities.
              </p>
              <a href="https://wa.link/nc2jpo" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-gray-400 rounded-md bg-gray-100 hover:bg-gray-200 transition-colors" data-id="element-3259">
                <span className="mr-2" data-id="element-3260">💬</span>
                Chat With Us on WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>;
  }
  return <div className="pt-20 bg-white min-h-screen" data-id="element-3261">
      <section className="relative py-16 border-b border-gray-200" data-id="element-3262">
        <div className="absolute inset-0 z-0" data-id="element-3263">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/veE5AXEU4CEztbBqZpUQcx/coverrs.png" alt="Host a Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-3264" />
          <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-3265"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-3266">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3267">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-3268">
              Host a Salon
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-3269">
              Create meaningful connections in your community
            </p>
          </div>
        </div>
      </section>
      <section className="py-16" data-id="element-3270">
        <div className="container mx-auto px-4" data-id="element-3271">
          <div className="max-w-3xl mx-auto" data-id="element-3272">
            <div className="bg-white p-6 rounded-lg border-2 border-gray-300" data-id="element-3273">
              <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-3274">
                Host a Networking Salon — Application Form
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-3275">
                We're excited that you'd like to host a Networking Salon!
                Hosting is more than putting people in a room — it's about
                curating meaningful conversations, creating safe spaces for
                connection, and upholding the values of The Networking Salon.
              </p>
              <p className="text-gray-700 mb-6" data-id="element-3276">
                This short form helps us understand your readiness, your
                audience, and how you plan to make your salon special.
              </p>
              {error && <div className="bg-gray-100 border-2 border-gray-400 text-gray-800 p-4 rounded-md mb-6" data-id="element-3277">
                  {error}
                </div>}
              <form onSubmit={handleSubmit} className="space-y-8" data-id="element-3278">
                <div className="space-y-6" data-id="element-3279">
                  <div data-id="element-3280">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-3281">
                      Section 1: Host Information
                    </h3>
                    <div className="space-y-4" data-id="element-3282">
                      <div data-id="element-3283">
                        <label htmlFor="fullName" className="block text-gray-700 font-medium mb-1" data-id="element-3284">
                          Full Name <span className="text-gray-500" data-id="element-3285">*</span>
                        </label>
                        <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3286" />
                      </div>
                      <div data-id="element-3287">
                        <label htmlFor="email" className="block text-gray-700 font-medium mb-1" data-id="element-3288">
                          Email Address <span className="text-gray-500" data-id="element-3289">*</span>
                        </label>
                        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3290" />
                      </div>
                      <div data-id="element-3291">
                        <label htmlFor="phone" className="block text-gray-700 font-medium mb-1" data-id="element-3292">
                          Phone Number (WhatsApp Preferred){' '}
                          <span className="text-gray-500" data-id="element-3293">*</span>
                        </label>
                        <input type="text" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3294" />
                      </div>
                      <div data-id="element-3295">
                        <label htmlFor="location" className="block text-gray-700 font-medium mb-1" data-id="element-3296">
                          City, Country <span className="text-gray-500" data-id="element-3297">*</span>
                        </label>
                        <input type="text" id="location" name="location" value={formData.location} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3298" />
                      </div>
                      <div data-id="element-3299">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-3300">
                          What best describes you?{' '}
                          <span className="text-gray-500" data-id="element-3301">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-3302">
                          {['Community Builder', 'Event Organizer', 'Business Owner / Founder', 'Professional / Creative', 'Student / Young Leader', 'Other'].map(option => <div key={option} className="flex items-center" data-id="element-3303">
                              <input type="radio" id={`role-${option}`} name="role" value={option} checked={formData.role === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3304" />
                              <label htmlFor={`role-${option}`} className="text-gray-700" data-id="element-3305">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      <div data-id="element-3306">
                        <label htmlFor="aboutYou" className="block text-gray-700 font-medium mb-1" data-id="element-3307">
                          Tell us a bit about yourself{' '}
                          <span className="text-gray-500" data-id="element-3308">*</span>
                          <span className="block text-sm text-gray-500" data-id="element-3309">
                            Include your background, what you do, and what
                            drives your interest in community building.
                          </span>
                        </label>
                        <textarea id="aboutYou" name="aboutYou" value={formData.aboutYou} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3310" />
                      </div>
                    </div>
                  </div>
                  <div data-id="element-3311">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-3312">
                      Section 2: Event Vision & Reach
                    </h3>
                    <div className="space-y-4" data-id="element-3313">
                      <div data-id="element-3314">
                        <label htmlFor="inspiration" className="block text-gray-700 font-medium mb-1" data-id="element-3315">
                          What inspired you to host a Networking Salon?{' '}
                          <span className="text-gray-500" data-id="element-3316">*</span>
                          <span className="block text-sm text-gray-500" data-id="element-3317">
                            We want to understand your motivation — what excites
                            you about this platform?
                          </span>
                        </label>
                        <textarea id="inspiration" name="inspiration" value={formData.inspiration} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3318" />
                      </div>
                      <div data-id="element-3319">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-3320">
                          Estimated Number of Attendees{' '}
                          <span className="text-gray-500" data-id="element-3321">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-3322">
                          {['20–50', '51–100', '101–200', 'More than 200'].map(option => <div key={option} className="flex items-center" data-id="element-3323">
                                <input type="radio" id={`attendees-${option}`} name="attendees" value={option} checked={formData.attendees === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3324" />
                                <label htmlFor={`attendees-${option}`} className="text-gray-700" data-id="element-3325">
                                  {option}
                                </label>
                              </div>)}
                        </div>
                      </div>
                      <div data-id="element-3326">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-3327">
                          Do you have an existing community or audience you can
                          invite? <span className="text-gray-500" data-id="element-3328">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-3329">
                          {['Yes', 'No'].map(option => <div key={option} className="flex items-center" data-id="element-3330">
                              <input type="radio" id={`existingCommunity-${option}`} name="existingCommunity" value={option} checked={formData.existingCommunity === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3331" />
                              <label htmlFor={`existingCommunity-${option}`} className="text-gray-700" data-id="element-3332">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      {formData.existingCommunity === 'Yes' && <div data-id="element-3333">
                          <label htmlFor="communityDescription" className="block text-gray-700 font-medium mb-1" data-id="element-3334">
                            If yes, please describe your community or network
                            <span className="block text-sm text-gray-500" data-id="element-3335">
                              Who are they? What connects them? How do you
                              normally engage with them?
                            </span>
                          </label>
                          <textarea id="communityDescription" name="communityDescription" value={formData.communityDescription} onChange={handleChange} rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3336" />
                        </div>}
                      <div data-id="element-3337">
                        <label htmlFor="promotionPlan" className="block text-gray-700 font-medium mb-1" data-id="element-3338">
                          How will you promote the event to ensure attendance?{' '}
                          <span className="text-gray-500" data-id="element-3339">*</span>
                          <span className="block text-sm text-gray-500" data-id="element-3340">
                            Share your plan — social media, word of mouth,
                            partnerships, campus networks, etc.
                          </span>
                        </label>
                        <textarea id="promotionPlan" name="promotionPlan" value={formData.promotionPlan} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3341" />
                      </div>
                      <div data-id="element-3342">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-3343">
                          Do you have experience organizing or co-hosting
                          events? <span className="text-gray-500" data-id="element-3344">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-3345">
                          {["Yes, I've organized events before", "Not yet, but I'm confident I can handle it"].map(option => <div key={option} className="flex items-center" data-id="element-3346">
                              <input type="radio" id={`experience-${option}`} name="experience" value={option} checked={formData.experience === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3347" />
                              <label htmlFor={`experience-${option}`} className="text-gray-700" data-id="element-3348">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      {formData.experience === "Yes, I've organized events before" && <div data-id="element-3349">
                          <label htmlFor="eventDescription" className="block text-gray-700 font-medium mb-1" data-id="element-3350">
                            If yes, briefly describe one event you've hosted or
                            contributed to
                          </label>
                          <textarea id="eventDescription" name="eventDescription" value={formData.eventDescription} onChange={handleChange} rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3351" />
                        </div>}
                    </div>
                  </div>
                  <div data-id="element-3352">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-3353">
                      Section 3: Alignment & Commitment
                    </h3>
                    <div className="space-y-4" data-id="element-3354">
                      <div data-id="element-3355">
                        <label htmlFor="engagementPlan" className="block text-gray-700 font-medium mb-1" data-id="element-3356">
                          The Networking Salon is about meaningful connection,
                          not just attendance. How will you ensure your guests
                          engage deeply and not just "show up"?{' '}
                          <span className="text-gray-500" data-id="element-3357">*</span>
                        </label>
                        <textarea id="engagementPlan" name="engagementPlan" value={formData.engagementPlan} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-3358" />
                      </div>
                      <div data-id="element-3359">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-3360">
                          Will you be available for a short orientation session
                          before hosting?{' '}
                          <span className="text-gray-500" data-id="element-3361">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-3362">
                          {['Yes, absolutely', "I'll need advance notice", 'Maybe, depending on timing'].map(option => <div key={option} className="flex items-center" data-id="element-3363">
                              <input type="radio" id={`orientationAvailability-${option}`} name="orientationAvailability" value={option} checked={formData.orientationAvailability === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3364" />
                              <label htmlFor={`orientationAvailability-${option}`} className="text-gray-700" data-id="element-3365">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      <div data-id="element-3366">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-3367">
                          Are you willing to document your salon (photos, short
                          recap, highlights) and share them with our team for
                          visibility? <span className="text-gray-500" data-id="element-3368">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-3369">
                          {['Yes', 'No'].map(option => <div key={option} className="flex items-center" data-id="element-3370">
                              <input type="radio" id={`documentationWillingness-${option}`} name="documentationWillingness" value={option} checked={formData.documentationWillingness === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3371" />
                              <label htmlFor={`documentationWillingness-${option}`} className="text-gray-700" data-id="element-3372">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-id="element-3373">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-3374">
                      Final Declaration
                    </h3>
                    <div data-id="element-3375">
                      <label className="block text-gray-700 font-medium mb-1" data-id="element-3376">
                        I understand that hosting a Networking Salon means
                        representing the brand's values of collaboration,
                        respect, and authenticity.{' '}
                        <span className="text-gray-500" data-id="element-3377">*</span>
                      </label>
                      <div className="space-y-2" data-id="element-3378">
                        {['Yes, I understand and agree', "I'd like to learn more first"].map(option => <div key={option} className="flex items-center" data-id="element-3379">
                            <input type="radio" id={`agreement-${option}`} name="agreement" value={option} checked={formData.agreement === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-3380" />
                            <label htmlFor={`agreement-${option}`} className="text-gray-700" data-id="element-3381">
                              {option}
                            </label>
                          </div>)}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pt-2" data-id="element-3382">
                  <Button type="submit" disabled={isSubmitting} className="w-full py-3" data-id="element-3383">
                    {isSubmitting ? 'Submitting...' : 'Submit Application'}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>;
};